class CartDrawerItems extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.init();
    window.addEventListener("load", () => {
      window.updatedCartCount();
    });
  }
  init() {
    window.openDrawer = this.handleOpen.bind(this);
    window.closeDrawer = this.handleClose.bind(this);
    window.renderCart = this.renderCart.bind(this);
    window.globalRenderCart = this.globalRenderCart.bind(this);
    window.updatedCartCount = this.updatedCartCount.bind(this);
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.handleClose();
      }
    });
  }
  handleOpen() {
    this.querySelector(".header--container").classList.add("cartDrawerActive");
  }
  handleClose() {
    this.querySelector(".header--container").classList.remove(
      "cartDrawerActive"
    );
  }
  async updatedCartCount() {
    try {
      const res = await fetch(`${window.Shopify.routes.root}cart.js`, {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      const data = await res.json();
      const countCircle = document.querySelectorAll(".countCircle");
      if (data.item_count > 0) {
        if (countCircle) {
          countCircle.forEach((item) => {
            item.style.display = "block";
          });
        }
      } else {
        countCircle.forEach((item) => {
          item.style.display = "none";
        });
      }
    } catch (error) {
      console.log(error);
    }
  }
  renderCart(html, open = false) {
    let drawer = this.closest(".cart-drawer-section");
    if (drawer) {
      let div = document.createElement("div");
      div.innerHTML = html;
      if (open) {
        div
          .querySelector(".header--container")
          .classList.add("cartDrawerActive");
      }
      drawer.innerHTML = div.querySelector(".cart-drawer-section").innerHTML;
    }
    window.updatedCartCount();
  }
  async globalRenderCart() {
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}?section_id=cart-drawer`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const html = await response.text();
      this.renderCart(html, true);
    } catch (error) {
      console.log(error);
    }
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);
// Quantity handler
class QuantityWrapper extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    setTimeout(() => {
      this.init();
    }, 500);
  }
  init() {
    const parentQtyWrapper = this.querySelector(".qty_parent-wrapper");
    if (parentQtyWrapper) {
      const itemKey = parentQtyWrapper.getAttribute("data-item-key");
      const inputQty = parentQtyWrapper.querySelector('input[type="number"]');
      const incrementBtn = parentQtyWrapper.querySelector(".incrementBtn");
      const decrementBtn = parentQtyWrapper.querySelector(".decrementBtn");
      if (incrementBtn) {
        incrementBtn.addEventListener("click", (e) => {
          e.preventDefault();
          this.incrementQty(itemKey, inputQty);
        });
      }
      if (decrementBtn) {
        decrementBtn.addEventListener("click", (e) => {
          e.preventDefault();
          this.decrementQty(itemKey, inputQty);
        });
      }
    }
  }
  incrementQty(itemKey, inputQty) {
    const button =
      this.closest(".cart-drawer__form").querySelector(".remove_btn");
    this.toggleLoader(button, true);
    const currentQty = Number(inputQty.value);
    const newQty = currentQty + 1;
    inputQty.value = newQty;
    this.updateCart(itemKey, newQty);
  }
  decrementQty(itemKey, inputQty) {
    const button =
      this.closest(".cart-drawer__form").querySelector(".remove_btn");
    this.toggleLoader(button, true);
    const currentQty = Number(inputQty.value);
    // const newQty = Math.max(1, currentQty - 1);
    const newQty = currentQty - 1;
    inputQty.value = newQty;
    this.updateCart(itemKey, newQty);
  }
  async updateCart(itemKey, newQty) {
    const button =
      this.closest(".cart-drawer__form").querySelector(".remove_btn");
    try {
      const res = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          updates: { [itemKey]: newQty },
          sections: "cart-drawer", // can be a string or array depending on Shopify setup
        }),
        // body: JSON.stringify({ updates: { [itemKey]: newQty} }),
      });
      const data = await res.json();
      this.toggleLoader(button, false);
      this.renderCart(data.sections["cart-drawer"], true);
    } catch (error) {
      this.toggleLoader(button, false);
      console.log(error);
    }
  }
  renderCart(html, open = false) {
    let drawer = this.closest(".cart-drawer-section");
    if (drawer) {
      let div = document.createElement("div");
      div.innerHTML = html;
      if (open) {
        div
          .querySelector(".header--container")
          .classList.add("cartDrawerActive");
      }
      drawer.innerHTML = div.querySelector(".cart-drawer-section").innerHTML;
    }
    window.updatedCartCount();
  }
  toggleLoader(button, show) {
    const loader = button.querySelector(".loader");
    const icon = button.querySelector("#icon-wrapper");

    // Agar button kisi wrapper ke andar hai jahan increment/decrement buttons hain:
    const parentQtyWrapper = this.querySelector(".qty_parent-wrapper");
    const incrementBtn = parentQtyWrapper?.querySelector(".incrementBtn");
    const decrementBtn = parentQtyWrapper?.querySelector(".decrementBtn");

    if (loader) {
      loader.style.display = show ? "block" : "none";
    }

    if (icon) {
      icon.style.display = show ? "none" : "block";
    }

    // Buttons ko show value ke basis pe enable/disable karna:
    if (incrementBtn) incrementBtn.disabled = show;
    if (decrementBtn) decrementBtn.disabled = show;
  }
}
customElements.define("cart-drawer-quantity-wrapper", QuantityWrapper);

// Cart Remove
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();

      const button = event.target.closest("button");
      if (!button) return;
      const currentIndex = button.getAttribute("data-index");
      const currentVariantId = button.getAttribute("data-variant-id");
      if (currentIndex && currentVariantId) {
        this.toggleLoader(button, true); // Show loader
        this.removeCurrentItem(currentIndex)
          .then(() => {
            this.toggleLoader(button, false); // Hide loader
          })
          .catch((error) => {
            console.error("Remove failed:", error);
            this.toggleLoader(button, false); // Hide on error too
          });
      }
    });
  }

  connectedCallback() {
    const button = this.querySelector("button");
    if (button) {
      this.toggleLoader(button, false); // Initially hide loader
    }
  }
  async removeCurrentItem(index) {
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart/change.js`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            line: Number(index),
            quantity: 0,
            sections: "cart-drawer",
          }),
        }
      );
      let data = await response.json();
      this.renderCart(data.sections["cart-drawer"]);
    } catch (error) {
      console.log(error);
    }
  }
  renderCart(html) {
    let drawer = this.closest(".cart-drawer-section");
    if (drawer) {
      let div = document.createElement("div");
      div.innerHTML = html;
      div.querySelector(".header--container").classList.add("cartDrawerActive");
      drawer.innerHTML = div.querySelector(".cart-drawer-section").innerHTML;
    }
    window.updatedCartCount();
  }
  toggleLoader(button, show) {
    const loader = button.querySelector(".loader");
    const icon = button.querySelector("#icon-wrapper");
    if (loader) {
      loader.style.display = show ? "block" : "none";
    }
    if (icon) {
      icon.style.display = show ? "none" : "block";
    }
  }
}
customElements.define("cart-remove-button", CartRemoveButton);
// Recommended products
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    setTimeout(() => {
      this.init();
    }, 500);
  }
  init() {
    const recommendationsPd = this.querySelector("#recommendedProduct");
    if (recommendationsPd) {
      const recommendationsPdId = recommendationsPd.getAttribute(
        "data-recommended-id"
      );
      this.fetchProductRecommendations(recommendationsPdId);
    }
  }
  async fetchProductRecommendations(productId) {
    try {
      const intentRelated = "related";
      const response = await fetch(
        `${window.Shopify.routes.root}recommendations/products.json?product_id=${productId}&intent=${intentRelated}`,
        {
          method: "get",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();

      const parentWrapper = this.querySelector("#recommendedProduct");
      if (data && data.products.length) {
        parentWrapper.style.display = "block";
        const wrapper = this.querySelector(
          "#recommendedProduct .embla-container"
        );
        wrapper.innerHTML = "";
        data.products.forEach((product) => {
          // Find first available variant whose title is not "1"
          let variant = null;
          let variantPrice = null;
          for (let v of product.variants) {
            if (v.available && v.title !== "1") {
              variant = v.id;
              variantPrice = v.price;
              break;
            }
          }
          // If all variants are unavailable or only variant "1" is available, fallback to first available
          if (!variant) {
            for (let v of product.variants) {
              if (v.available) {
                variant = v.id;
                variantPrice = v.price;
                break;
              }
            }
          }
          const slide = document.createElement("div");
          slide.className = "embla-slide";
          slide.style.flex = "0 0 calc(33.333% - 4px)";
          slide.style.paddingLeft = "6px";
          slide.innerHTML = `
                  <div class="w-full">

                    <a href="${
                      product.url
                    }" class=" relative block w-full h-full  aspect-square max-sm:h-[110px] max-sm:p-4 bg-[#D4E0FF] rounded-[7.31px] pt-[18px] pb-[17px] px-[25px] mb-[9px] overflow-hidden">
                      
                      <img src="${product.featured_image}" alt="${
            product.title
          }" class="w-full h-full object-contain">
                                <div class="flex items-center justify-center"
                        x-data="{
                            product: ${variant},
                            variant: ${variant},
                            loading: false,
                            error: null
                          }"
                      >
                        <p class="text-red-500" x-show="error != null" x-text="error"></p>
                        <button
                        ${product.available && variant ? "" : "disabled"}
                          x-on:click="
                            event.preventDefault();
                            loading = true;
                            fetch('/cart/add.js', {
                              method: 'POST',
                              headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                              },
                              body: JSON.stringify({
                                items: [{
                                  id: variant,
                                  quantity: 1
                                }],
                                sections: 'cart-drawer'
                              })
                            })
                            .then(response => response.json())
                            .then(data => {
                              if(data.status && data.status !== 200) {
                                throw new Error(data.description || 'Failed to add product to cart');
                              }
                              window.renderCart(data.sections['cart-drawer'], true);
                            })
                            .catch(err => {
                              error = err.message || 'An error occurred while adding the product to the cart';
                              loading = false;
                            }).finally(()=>{ loading = false; });"
                        class="add-to-cart_recommendations"
                        >
                          <span x-show="!loading">${
                            product.available && variant
                              ? "Add to cart"
                              : "Coming soon!"
                          }</span>
                          <div class="loader" style="border-color: #12284c;" x-show="loading" x-cloak></div>
                        </button>
                      </div>
                    </a>
                    <div class="text-center">
                      <a href="${
                        product.url
                      }" class="text-sm font-cabinet font-extrabold leading-[101%] text-primary-800 inline-block recommendation__product-name mb-2">
                        ${product.title}
                      </a>
                      <p class="text-sm font-gotham font-bold leading-[93%] uppercase text-primary-800 mt-[10px] mb-[13px] max-sm:mb-[5px] max-sm:mt-[5px]">
                           $${
                             variantPrice !== null
                               ? (variantPrice / 100).toFixed(2)
                               : (product.price / 100).toFixed(2)
                           }
                      </p>

                    </div>
                  </div>
                `;
          wrapper.appendChild(slide);
        });

        // Initialize Embla after dynamically adding slides
        if (typeof EmblaCarousel !== "undefined") {
          const emblaNode = this.querySelector(".recommended-embla");
          const viewportNode = emblaNode.querySelector(".embla-viewport");
          const prevButton = this.querySelector(".embla-prev");
          const nextButton = this.querySelector(".embla-next");

          const embla = EmblaCarousel(viewportNode, {
            loop: true,
            align: "start",
            slidesToScroll: 1,
            draggable: true,
          });

          if (prevButton) {
            prevButton.addEventListener("click", () => embla.scrollPrev());
          }
          if (nextButton) {
            nextButton.addEventListener("click", () => embla.scrollNext());
          }
        }
      }
    } catch (error) {
      console.error("Error loading product recommendations:", error);
    }
  }
}
customElements.define("cart-drawer-recommendation", ProductRecommendations);
